import { Box } from "@mui/material";
import Image from "next/image";
import { Images } from "../branding";
import styles from "./HeroContent.module.css";

export const HeroContent = () => {
  return (
    <Box className={styles.content}>
      {Images.heroLogo && (
        <Box className={styles.logo}>
          <Image
            src={Images.heroLogo.src}
            alt={Images.heroLogo.alt}
            width={Images.heroLogo.width}
            height={Images.heroLogo.height}
            priority
          />
        </Box>
      )}
      <h1 className={styles.title}>
        Choose the Protection That Fits Your Trip
      </h1>
      <p className={styles.text}>
        Enter your trip details to review up to three options: Post-Departure
        Coverage, Basic Trip Cancellation, and Cancel for Any Reason Coverage
        when available.
      </p>
      <p className={styles.text}>
        We recommend that every traveler purchase Post-Departure Coverage at a
        minimum for medical emergencies, evacuation, delays, baggage, and other
        unexpected issues while traveling.
      </p>
    </Box>
  );
};
